<style lang="stylus" scoped>
    .userdialog-line
        width 100%
        padding-left 32px
        display flex
        justify-content flex-end
        .userdialog
            padding 12px
            background var(--bg-color-ai-user-msg)
            border-radius 6px
            p
                color var(--text-color-black)
                font-size 12px
                line-height 16px
                word-break break-word
            .userdialog-input-file
                display flex
                align-items center
                // height 32px
                background var(--bg-color-ai-user-msg-file)
                border-radius 4px
                padding 8px 12px;
                &.picture
                    padding 0;
                    height auto;
                    margin-bottom 8px;
                    background transparent;
                    &:last-child
                        margin-bottom 0
                    .icon
                        width 100%;
                        max-width: 272px;
                        height auto;
                        margin 0;
                        &.height-auto
                            height 100%;
                            width auto;
                &.text-margin
                    margin-bottom 8px
                .icon
                    width 32px
                    height 32px
                    margin-right 4px
</style>

<template>
    <div class="userdialog-line" v-if="msgType == userMsgType.text">
        <div class="userdialog">
            <p v-for="(item, index) in fitStrList" :key="index">{{ item }}</p>
        </div>
    </div>
    <div class="userdialog-line" v-else-if="msgType == userMsgType.file">
        <div class="userdialog">
            <div class="userdialog-input-file" :class="{ 'text-margin': fitStrList.length > 0 }">
                <img class="icon" :src="require(`@/app/assets/img/ai3/${fileIconName}.svg`)" alt="" />
                <p class="text" :title="fileName">{{ shortText(fileName) }}</p>
            </div>
            <p v-for="(item, index) in fitStrList" :key="index">{{ item }}</p>
        </div>
    </div>
    <div class="userdialog-line picture-dialog" v-else-if="msgType == userMsgType.picture">
        <div class="userdialog">
            <div class="userdialog-input-file picture" v-for="item in pictures" :key="item.url" :class="{ 'text-margin': fitStrList.length > 0 }">
                <img class="icon" :src="item.url" alt="" :class="{ 'with-auto': item.wth > 0.5, 'height-auto': item.htw > 0.5 && item.wth < 0.5 }" />
            </div>
            <p v-for="(item, index) in fitStrList" :key="index">{{ item }}</p>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import { userMsgType } from "./enum";
    @Component
    export default class UserDialog extends Vue {
        @Prop()
        str;
        @Prop()
        msgType;
        @Prop()
        fileName;
        @Prop()
        fileType;
        @Prop()
        pictures;

        get userMsgType() {
            return userMsgType;
        }
        get fileIconName() {
            if (["xlsx", "csv", "xls"].includes(this.fileType)) {
                return "excel";
            }
            return this.fileType == "txt" ? "txt" : this.fileType == "pdf" ? "pdf" : "doc";
        }
        get fitStrList() {
            let arr = this.str.split("\n") || [];
            return arr.filter((item) => item != "");
        }
        shortText(str) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            ctx.font = "12px 'Microsoft YaHei'";
            let strLength = ctx.measureText(str);
            if (strLength.width > 268) {
                let pointLength = ctx.measureText("...");
                let partLength = (268 - pointLength.width) / 2;
                let strArr = str.split("");
                let prevStr = "";
                let suffStr = "";
                let extraPX = 0;
                for (let i = 0; i < strArr.length; i++) {
                    let temp = prevStr;
                    temp += strArr[i];
                    let width = ctx.measureText(temp).width;
                    if (width > partLength) {
                        extraPX = partLength - ctx.measureText(prevStr).width;
                        break;
                    }
                    prevStr = temp;
                }
                for (let i = strArr.length - 1; i >= 0; i--) {
                    let temp = suffStr;
                    temp += strArr[i];
                    let width = ctx.measureText(temp).width;
                    if (width > partLength + extraPX) {
                        break;
                    }
                    suffStr = temp;
                }
                suffStr = suffStr.split("").reverse().join("");
                return `${prevStr}...${suffStr}`;
            } else {
                return str;
            }
        }
    }
</script>
